import React, { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import CustomDataTable from "../../../components/CustomDataTable";
import Header from "../../../components/Header";
import Aside from "../../../components/Aside";
import { useTranslation } from "react-i18next";
import { DateUtil } from "../../../utils/date";
import useRequest from "../../../hooks/useRequest";
import { BlacklistWordsConfigService } from "../../../services/BlacklistWordsConfigService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";

function BlacklistWordsPage() {
    const { account } = useCurrentAccount();
  const { t, i18n } = useTranslation();
  const [list, setList] = useState([])
  const { call, isRequesting } = useRequest();
  
  const columns = [
    {
      name: 'Agente',
      sortable: false,
      center: false,
      selector: row => row.username ,
    },
    {
      name: 'Palabra',
      sortable: false,
      center: false,
      selector: row => row.word ,
    },
    {
      name: 'Mensaje',
      sortable: false,
      center: false,
      selector: row => row.original_text ,
    },
    {
      name: 'Fecha',
      sortable: false,
      center: false,
      selector: row => DateUtil.format(row.inserted_at),
    },
  ];

  const getReport = async() => {
    const { data } = await call(() => BlacklistWordsConfigService.getReport(account.account_id));
    setList(data)
  }

  useEffect(() => {
    getReport();
  }, []);
  

  return (
    <>
      <Header />
      <Aside />
      <main id="content" role="main" className="main">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm mb-2 mb-sm-0">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb breadcrumb-no-gutter">
                    <li className="breadcrumb-item ">
                      <span className="breadcrumb-link">
                        {t("reports.operation-title")}
                      </span>
                    </li>
                    <li className="breadcrumb-item " aria-current="page">
                      <span className="breadcrumb-link ">
                        {t("reports.reports-title")}
                      </span>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Palabras prohibidas
                    </li>
                  </ol>
                </nav>
                <h1 className="page-header-title text-white-dark">
                  <i className="bi-grid-1x2-fill text-primary nav-icon"></i>{" "}
                  {t("reports.reports-title")} - Palabras prohibidas
                </h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <CustomDataTable
                columns={columns}
                data={list}
                hideAccountsFilter
                showExport={true}
                isLoading={isRequesting}
                filter={(row, term) => {
                  if (!term) return true;

                  return (
                    `${row.word}`.match(new RegExp(`${term}`, "i")) ||
                    `${row.original_text}`.match(new RegExp(`${term}`, "i")) ||
                    `${row.username}`.match(new RegExp(`${term}`, "i"))
                  );
                }}
              />
            </div>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default BlacklistWordsPage;
